import { render, staticRenderFns } from "./RoleQuestionTable.vue?vue&type=template&id=073d1424"
import script from "./RoleQuestionTable.vue?vue&type=script&lang=js"
export * from "./RoleQuestionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports